import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
  autoClose: 5000,
  draggable: false,
});

const ErrorToast = ({ errorMsg, errorClass }) => {

  if(!!errorMsg)
  {
    if(errorClass === 'alert alert-success') {
      toast.success(errorMsg, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    } else {
      toast.warning(errorMsg, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }
  }

      useEffect(() => {
      toast.dismiss();
      return () => {
       toast.dismiss();
      }
    }, []);
      
  return <div></div>
}

const mapStateToProps = (state) => {
  if(typeof    state.rootReducer.utils.errorPanel.panelMsg != 'undefined')
  {
    return {
      errorMsg: state.rootReducer.utils.errorPanel.panelMsg.panelMsg,
      errorClass: state.rootReducer.utils.errorPanel.panelMsg.panelClass,
    }
  } else {
    return {
      errorMsg: '',
      errorClass: ''
    }
  }
}

export default connect(mapStateToProps)(ErrorToast);
